import { useState } from "react";
import { decrypt, decryptByText, encrypt, encryptByText } from "../../helpers/bycrypt";

const Crypto = () => {
    /* local state for four little forms */
    const [toEnc, setToEnc] = useState("");
    const [encRes, setEncRes] = useState("");

    const [toDec, setToDec] = useState("");
    const [decRes, setDecRes] = useState("");

    const [toEncChar, setToEncChar] = useState("");
    const [encCharRes, setEncCharRes] = useState("");

    const [toDecChar, setToDecChar] = useState("");
    const [decCharRes, setDecCharRes] = useState("");

    /* handlers */
    const handleEncrypt = () => setEncRes(encrypt(toEnc));
    const handleDecrypt = () => setDecRes(decrypt(toDec));
    const handleEncryptByTxt = async () => setEncCharRes(await encryptByText(toEncChar));
    const handleDecryptByTxt = () => setDecCharRes(decryptByText(toDecChar));

    return (
        <div style={{ maxWidth: 600, margin: "auto", fontFamily: "sans-serif" }}>
            <h2>AES–CBC Demo (CryptoJS)</h2>

            {/* --------------- simple encrypt ---------------- */}
            <fieldset>
                <legend>Encrypt (whole string)</legend>
                <textarea rows={3} value={toEnc} onChange={e => setToEnc(e.target.value)} />
                <br />
                <button onClick={handleEncrypt}>Encrypt</button>
                {encRes && (
                    <p><strong>Cipher:</strong><br />{encRes}</p>
                )}
            </fieldset>

            {/* --------------- simple decrypt ---------------- */}
            <fieldset>
                <legend>Decrypt (whole string)</legend>
                <textarea rows={3} value={toDec} onChange={e => setToDec(e.target.value)} />
                <br />
                <button onClick={handleDecrypt}>Decrypt</button>
                {decRes && (
                    <p><strong>Plain:</strong><br />{decRes}</p>
                )}
            </fieldset>

            {/* --------------- per-character encrypt --------- */}
            <fieldset>
                <legend>Encrypt by Character</legend>
                <textarea rows={3} value={toEncChar} onChange={e => setToEncChar(e.target.value)} />
                <br />
                <button onClick={handleEncryptByTxt}>Encrypt By Text</button>
                {encCharRes && (
                    <p><strong>Cipher (-per-char):</strong><br />{encCharRes}</p>
                )}
            </fieldset>

            {/* --------------- per-character decrypt --------- */}
            <fieldset>
                <legend>Decrypt by Character</legend>
                <textarea rows={3} value={toDecChar} onChange={e => setToDecChar(e.target.value)} />
                <br />
                <button onClick={handleDecryptByTxt}>Decrypt By Text</button>
                {decCharRes && (
                    <p><strong>Plain (-per-char):</strong><br />{decCharRes}</p>
                )}
            </fieldset>
        </div>
    );
};

export default Crypto;